exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.template-summary p[data-v-735c83e4] {\n  font-size: 16px;\n  line-height: 24px;\n}\n.template-summary .logistic-provider-logo[data-v-735c83e4] {\n  width: 120px;\n}\n", "", {"version":3,"sources":["/usr/src/app/node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/components/BillingTemplateSummary.vue"],"names":[],"mappings":";AAsCA;EAEI,gBAAe;EACf,kBAAiB;CAClB;AAJH;EAOI,aAAY;CACb","file":"BillingTemplateSummary.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.template-summary {\n  p {\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  .logistic-provider-logo {\n    width: 120px;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-735c83e4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/components/BillingTemplateSummary.vue
// module id = XGYD
// module chunks = 72